const DESLOC_API_BASE = "https://alerta-maceio-api-production.up.railway.app/api";
const DESLOC_CONTACTS_KEY = "vigial_trusted_contacts_v1";
const DESLOC_MAX_CONTACTS = 2;
const DESLOC_RISK_CATS = ["roubo", "veiculo", "suspeito", "arrombamento", "furto", "trafico", "agressao"];
const DESLOC_ARRIVAL_RADIUS_M = 70;
const DESLOC_ALERT_RADIUS_M = 180;
const DESLOC_GPS_MIN_INTERVAL_MS = 20000;
const DESLOC_REPORTS_REFRESH_MS = 90000;
const DESLOC_INACTIVITY_SECONDS = 60;
const DESLOC_TIME_PRESETS = [5, 10, 15, 20, 30];

function loadTrustedContacts() {
  try { return JSON.parse(localStorage.getItem(DESLOC_CONTACTS_KEY) || "[]"); } catch (e) { return []; }
}
function saveTrustedContacts(list) {
  try { localStorage.setItem(DESLOC_CONTACTS_KEY, JSON.stringify(list)); } catch (e) {}
}

function formatMMSS(totalSeconds) {
  const s = Math.max(0, Math.round(totalSeconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, "0")}`;
}
function formatDistanceM(m) {
  if (m == null) return "--";
  if (m >= 1000) return `${(m / 1000).toFixed(2)} km`;
  return `${Math.round(m)} m`;
}
function normalizePhoneToWa(phone) {
  let digits = (phone || "").replace(/\D/g, "");
  if (digits.length <= 11) digits = "55" + digits;
  return digits;
}
function waLink(phone, text) {
  return `https://wa.me/${normalizePhoneToWa(phone)}?text=${encodeURIComponent(text)}`;
}

function apiCreateTrip(payload) {
  return fetch(`${DESLOC_API_BASE}/trip`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
  }).then((r) => r.json()).catch(() => null);
}
function apiPingTrip(tripId, lat, lng) {
  fetch(`${DESLOC_API_BASE}/trip/${tripId}/ping`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ lat, lng }),
  }).catch(() => {});
}
function apiSetTripStatus(tripId, status, pos) {
  fetch(`${DESLOC_API_BASE}/trip/${tripId}/status`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify(pos ? { status, lat: pos.lat, lng: pos.lng } : { status }),
  }).catch(() => {});
}
function apiNotifyTripContacts(tripId, contacts, senderName, pos) {
  const deviceId = window.getDeviceId ? window.getDeviceId() : null;
  return fetch(`${DESLOC_API_BASE}/trip/${tripId}/notify-contacts`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      deviceId, senderName,
      contacts: contacts.map((c) => ({ name: c.name, email: c.email })),
      lat: pos ? pos.lat : undefined, lng: pos ? pos.lng : undefined,
    }),
  }).then((r) => r.json()).catch(() => null);
}
function buildTripShareUrl(tripId) {
  const dir = window.location.pathname.replace(/[^/]*$/, "");
  return `${window.location.origin}${dir}trip.html?id=${tripId}`;
}

function playDeslocBeep(ctxRef, times, freq) {
  try {
    if (!ctxRef.current) ctxRef.current = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = ctxRef.current;
    for (let i = 0; i < (times || 1); i++) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq || 880;
      gain.gain.value = 0.001;
      const start = ctx.currentTime + i * 0.28;
      osc.connect(gain);
      gain.connect(ctx.destination);
      gain.gain.exponentialRampToValueAtTime(0.18, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.2);
      osc.start(start);
      osc.stop(start + 0.22);
    }
  } catch (e) {}
}
function vibrateDesloc(pattern) {
  try { navigator.vibrate && navigator.vibrate(pattern); } catch (e) {}
}

function ContactsManager({ lang, contacts, setContacts }) {
  const { Icon, Button } = window.VigiALDesignSystem_ff2dec;
  const [adding, setAdding] = React.useState(false);
  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");

  function addContact() {
    if (!name.trim() || (!phone.trim() && !email.trim())) return;
    const next = [...contacts, { id: "ct" + Date.now(), name: name.trim(), phone: phone.trim(), email: email.trim() }];
    setContacts(next);
    saveTrustedContacts(next);
    setName(""); setPhone(""); setEmail(""); setAdding(false);
  }
  function removeContact(id) {
    const next = contacts.filter((c) => c.id !== id);
    setContacts(next);
    saveTrustedContacts(next);
  }

  return (
    <div style={{ marginTop: 4 }}>
      <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 6 }}>{t(lang, "deslocContactsTitle")}</div>
      {contacts.map((c) => (
        <div key={c.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", border: "1px solid var(--color-border)", borderRadius: 9, marginBottom: 6 }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name}</div>
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-mono)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {[c.phone, c.email].filter(Boolean).join(" · ")}
            </div>
            {!c.email && <div style={{ fontSize: 10, color: "var(--color-warning)", marginTop: 2 }}>{t(lang, "deslocContactNoEmailHint")}</div>}
          </div>
          <button onClick={() => removeContact(c.id)} style={{ background: "transparent", border: "none", cursor: "pointer", padding: 4, flexShrink: 0 }}>
            <Icon name="x" size={15} color="var(--color-text-muted)" />
          </button>
        </div>
      ))}
      {adding ? (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: 9, padding: 10 }}>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder={t(lang, "deslocContactName")}
            style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 8, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 6 }} />
          <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t(lang, "deslocContactEmail")} type="email"
            style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 8, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 4 }} />
          <div style={{ fontSize: 10, color: "var(--color-text-muted)", marginBottom: 6 }}>{t(lang, "deslocContactEmailHint")}</div>
          <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={t(lang, "deslocContactPhone")}
            style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 8, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 8 }} />
          <div style={{ display: "flex", gap: 8 }}>
            <Button variant="ghost" onClick={() => { setAdding(false); setName(""); setPhone(""); setEmail(""); }} style={{ flex: 1 }}>{t(lang, "cancel")}</Button>
            <Button variant="primary" onClick={addContact} disabled={!name.trim() || (!phone.trim() && !email.trim())} style={{ flex: 1 }}>{t(lang, "deslocContactSave")}</Button>
          </div>
        </div>
      ) : contacts.length < DESLOC_MAX_CONTACTS ? (
        <button onClick={() => setAdding(true)} style={{ background: "transparent", border: "none", cursor: "pointer", color: "var(--color-brand-primary)", fontSize: "var(--text-xs)", padding: 0, display: "flex", alignItems: "center", gap: 3 }}>
          <Icon name="plus" size={12} color="var(--color-brand-primary)" /> {t(lang, "deslocAddContact")}
        </button>
      ) : (
        <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "deslocContactLimitMsg")}</div>
      )}
    </div>
  );
}

function DeslocMap({ pos, path, dest }) {
  const mapDivRef = React.useRef(null);
  const mapRef = React.useRef(null);
  const markerRef = React.useRef(null);
  const lineRef = React.useRef(null);
  const destMarkerRef = React.useRef(null);

  React.useEffect(() => {
    if (!mapDivRef.current || mapRef.current || !pos) return;
    const map = L.map(mapDivRef.current, { zoomControl: false, scrollWheelZoom: true, touchZoom: true, attributionControl: false }).setView([pos.lat, pos.lng], 15);
    L.tileLayer(window.VIGI_TILE_URL, window.VIGI_TILE_OPTIONS).addTo(map);
    const icon = L.divIcon({ className: "", html: '<div class="vigi-map-pin pulse" style="background:var(--color-brand-primary)"></div>', iconSize: [20, 20], iconAnchor: [10, 10] });
    markerRef.current = L.marker([pos.lat, pos.lng], { icon }).addTo(map);
    mapRef.current = map;
  }, []);

  React.useEffect(() => {
    const map = mapRef.current;
    if (!map || !pos) return;
    if (markerRef.current) markerRef.current.setLatLng([pos.lat, pos.lng]);
    if (lineRef.current) map.removeLayer(lineRef.current);
    if (path && path.length > 1) {
      lineRef.current = L.polyline(path.map((p) => [p.lat, p.lng]), { color: "var(--color-brand-primary)", weight: 3, opacity: 0.7 }).addTo(map);
    }
    if (dest) {
      if (!destMarkerRef.current) {
        const dIcon = L.divIcon({ className: "", html: '<div class="vigi-map-pin" style="background:var(--color-alert)"></div>', iconSize: [16, 16], iconAnchor: [8, 8] });
        destMarkerRef.current = L.marker([dest.lat, dest.lng], { icon: dIcon }).addTo(map);
      }
      map.fitBounds(L.latLngBounds([[pos.lat, pos.lng], [dest.lat, dest.lng]]), { padding: [24, 24] });
    } else {
      map.panTo([pos.lat, pos.lng]);
    }
  }, [pos, path, dest]);

  React.useEffect(() => () => { if (mapRef.current) mapRef.current.remove(); }, []);

  return <div ref={mapDivRef} style={{ height: 150, borderRadius: 9, overflow: "hidden", position: "relative", zIndex: 0, border: "1px solid var(--color-border)" }} />;
}

function DeslocamentoMode({ lang, showToast }) {
  const { Button, Icon, Chip } = window.VigiALDesignSystem_ff2dec;
  const [premium, setPremiumFlag] = React.useState(() => (window.isPremium ? window.isPremium() : false));
  const [shareUrl, setShareUrl] = React.useState("");
  const tripIdRef = React.useRef(null);
  const [contacts, setContacts] = React.useState(loadTrustedContacts);
  const [tripMode, setTripMode] = React.useState("time");
  const [durationMin, setDurationMin] = React.useState(15);
  const [customMin, setCustomMin] = React.useState("");
  const [destQuery, setDestQuery] = React.useState("");
  const [destPoint, setDestPoint] = React.useState(null);
  const [setupError, setSetupError] = React.useState("");

  const [phase, setPhase] = React.useState("setup");
  const [remainingSec, setRemainingSec] = React.useState(0);
  const [distanceRemainingM, setDistanceRemainingM] = React.useState(null);
  const [currentPos, setCurrentPos] = React.useState(null);
  const [path, setPath] = React.useState([]);
  const [riskBanner, setRiskBanner] = React.useState(null);
  const [inactivitySec, setInactivitySec] = React.useState(DESLOC_INACTIVITY_SECONDS);

  const watchIdRef = React.useRef(null);
  const tickRef = React.useRef(null);
  const reportsRefreshRef = React.useRef(null);
  const inactivityRef = React.useRef(null);
  const alertedIdsRef = React.useRef(new Set());
  const riskReportsRef = React.useRef([]);
  const lastGpsTsRef = React.useRef(0);
  const endAtRef = React.useRef(0);
  const audioCtxRef = React.useRef(null);
  const bannerTimerRef = React.useRef(null);
  const phaseRef = React.useRef(phase);
  phaseRef.current = phase;

  function clearAllTimers() {
    if (watchIdRef.current != null) { navigator.geolocation.clearWatch(watchIdRef.current); watchIdRef.current = null; }
    clearInterval(tickRef.current); tickRef.current = null;
    clearInterval(reportsRefreshRef.current); reportsRefreshRef.current = null;
    clearInterval(inactivityRef.current); inactivityRef.current = null;
    clearTimeout(bannerTimerRef.current); bannerTimerRef.current = null;
  }

  React.useEffect(() => () => clearAllTimers(), []);

  function fetchRiskReports() {
    fetch(`${DESLOC_API_BASE}/reports?window=24h`)
      .then((r) => r.json())
      .then((list) => {
        riskReportsRef.current = (list || []).filter((r) => DESLOC_RISK_CATS.includes(r.category));
        checkRiskProximity(currentPosRef.current);
      })
      .catch(() => {});
  }

  const currentPosRef = React.useRef(null);
  currentPosRef.current = currentPos;

  function checkRiskProximity(pos) {
    if (!pos || !window.haversineKm) return;
    for (const r of riskReportsRef.current) {
      if (alertedIdsRef.current.has(r.id)) continue;
      const distM = window.haversineKm(pos.lat, pos.lng, r.lat, r.lng) * 1000;
      if (distM <= DESLOC_ALERT_RADIUS_M) {
        alertedIdsRef.current.add(r.id);
        triggerRiskAlert(r);
        break;
      }
    }
  }

  function triggerRiskAlert(report) {
    const catLabel = catLabelFor(lang, report.category);
    setRiskBanner({ catLabel });
    playDeslocBeep(audioCtxRef, 2, 740);
    vibrateDesloc([180, 90, 180]);
    clearTimeout(bannerTimerRef.current);
    bannerTimerRef.current = setTimeout(() => setRiskBanner(null), 7000);
  }

  function handlePosition(pos) {
    const now = Date.now();
    const { latitude, longitude } = pos.coords;
    if (now - lastGpsTsRef.current < DESLOC_GPS_MIN_INTERVAL_MS) return;
    lastGpsTsRef.current = now;
    const nextPos = { lat: latitude, lng: longitude };
    setCurrentPos(nextPos);
    setPath((prev) => [...prev.slice(-199), nextPos]);
    if (tripIdRef.current) apiPingTrip(tripIdRef.current, latitude, longitude);
    if (destPoint && window.haversineKm) {
      const distM = window.haversineKm(latitude, longitude, destPoint.lat, destPoint.lng) * 1000;
      setDistanceRemainingM(distM);
      if (distM <= DESLOC_ARRIVAL_RADIUS_M && phaseRef.current === "active") triggerConfirmPhase();
    }
    checkRiskProximity(nextPos);
  }

  async function startTrip() {
    setSetupError("");
    const minutes = tripMode === "time" ? (Number(customMin) || durationMin) : null;
    if (tripMode === "time" && (!minutes || minutes <= 0)) { setSetupError(t(lang, "deslocNeedTime")); return; }
    if (tripMode === "destination" && !destPoint) { setSetupError(t(lang, "deslocNeedDest")); return; }
    if (!navigator.geolocation) { setSetupError(t(lang, "noLocationAccess")); return; }

    playDeslocBeep(audioCtxRef, 1, 1000);
    alertedIdsRef.current = new Set();
    setPath([]);
    setRiskBanner(null);
    setPhase("active");
    tripIdRef.current = null;
    setShareUrl("");

    if (tripMode === "time") {
      endAtRef.current = Date.now() + minutes * 60000;
      setRemainingSec(minutes * 60);
    } else {
      setDistanceRemainingM(null);
    }

    const trip = await apiCreateTrip({
      deviceId: window.getDeviceId ? window.getDeviceId() : null,
      mode: tripMode,
      durationMin: tripMode === "time" ? minutes : undefined,
      destLat: tripMode === "destination" ? destPoint.lat : undefined,
      destLng: tripMode === "destination" ? destPoint.lng : undefined,
      destName: tripMode === "destination" ? destQuery : undefined,
    });
    if (trip && trip.id) {
      tripIdRef.current = trip.id;
      setShareUrl(buildTripShareUrl(trip.id));
    }
    if (window.trackEvent) window.trackEvent("trip_start");

    navigator.geolocation.getCurrentPosition((pos) => handlePosition(pos), () => {}, { enableHighAccuracy: true, timeout: 8000 });
    watchIdRef.current = navigator.geolocation.watchPosition(handlePosition, () => {}, { enableHighAccuracy: false, maximumAge: 15000, timeout: 20000 });

    fetchRiskReports();
    reportsRefreshRef.current = setInterval(fetchRiskReports, DESLOC_REPORTS_REFRESH_MS);

    if (tripMode === "time") {
      tickRef.current = setInterval(() => {
        const secLeft = Math.round((endAtRef.current - Date.now()) / 1000);
        setRemainingSec(Math.max(0, secLeft));
        if (secLeft <= 0 && phaseRef.current === "active") triggerConfirmPhase();
      }, 1000);
    }
  }

  function triggerConfirmPhase() {
    clearInterval(tickRef.current); tickRef.current = null;
    setPhase("confirm");
    playDeslocBeep(audioCtxRef, 2, 660);
    vibrateDesloc([200, 100, 200]);
    if (premium) startInactivityCountdown();
  }

  function startInactivityCountdown() {
    setInactivitySec(DESLOC_INACTIVITY_SECONDS);
    clearInterval(inactivityRef.current);
    inactivityRef.current = setInterval(() => {
      setInactivitySec((prev) => {
        const next = prev - 1;
        if (next <= 10) { playDeslocBeep(audioCtxRef, 1, 880); vibrateDesloc([150]); }
        if (next <= 0) {
          clearInterval(inactivityRef.current); inactivityRef.current = null;
          onInactivityExpired();
          return 0;
        }
        return next;
      });
    }, 1000);
  }

  function cancelInactivityCountdown() {
    clearInterval(inactivityRef.current); inactivityRef.current = null;
  }

  function extendTrip(extraMinutes) {
    cancelInactivityCountdown();
    endAtRef.current = Date.now() + extraMinutes * 60000;
    setRemainingSec(extraMinutes * 60);
    setPhase("active");
    tickRef.current = setInterval(() => {
      const secLeft = Math.round((endAtRef.current - Date.now()) / 1000);
      setRemainingSec(Math.max(0, secLeft));
      if (secLeft <= 0 && phaseRef.current === "active") triggerConfirmPhase();
    }, 1000);
  }

  function confirmArrivedSafe() {
    cancelInactivityCountdown();
    if (tripIdRef.current) apiSetTripStatus(tripIdRef.current, "arrived", currentPosRef.current);
    clearAllTimers();
    setPhase("endedSafe");
  }

  function cancelTrip() {
    cancelInactivityCountdown();
    if (tripIdRef.current) apiSetTripStatus(tripIdRef.current, "cancelled", currentPosRef.current);
    clearAllTimers();
    setPhase("setup");
  }

  function onInactivityExpired() {
    setPhase("notifying");
    const pos = currentPosRef.current;
    // The server call below both marks the trip "panic" and emails every
    // contact with an email on file — it replaces the old status-only
    // ping, since that email is now the actual "automatic" notification
    // the Premium copy promises (a WhatsApp link the person still has to
    // tap "send" on isn't automatic). The WhatsApp links below stay as a
    // free bonus for contacts who only left a phone number, best-effort.
    const senderProfile = window.loadProfile ? window.loadProfile() : null;
    const senderName = senderProfile ? (senderProfile.username || senderProfile.name || "") : "";
    if (tripIdRef.current) {
      apiNotifyTripContacts(tripIdRef.current, contacts, senderName, pos);
    }
    const mapsUrl = pos ? `https://www.google.com/maps?q=${pos.lat},${pos.lng}` : "";
    const msg = t(lang, "deslocPanicMessage") + (mapsUrl ? ` ${mapsUrl}` : "");
    contacts.forEach((c) => {
      if (!c.phone) return;
      try { window.open(waLink(c.phone, msg), "_blank"); } catch (e) {}
    });
    setTimeout(() => setPhase("endedPanic"), 1400);
  }

  function shareTrip() {
    if (!shareUrl) return;
    const text = tripMode === "time" ? t(lang, "deslocShareTextTime") : t(lang, "deslocShareTextDest");
    if (navigator.share) {
      navigator.share({ title: t(lang, "deslocShareTitle"), text, url: shareUrl }).catch(() => {});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(`${text} ${shareUrl}`).then(() => {
        showToast && showToast(t(lang, "deslocShareCopied"));
      }).catch(() => {});
    }
  }

  function newTrip() {
    clearAllTimers();
    setPhase("setup");
    setDestQuery("");
    setDestPoint(null);
    setRiskBanner(null);
    tripIdRef.current = null;
    setShareUrl("");
  }

  const lastPosForPanic = currentPosRef.current;
  const panicMsg = t(lang, "deslocPanicMessage") + (lastPosForPanic ? ` https://www.google.com/maps?q=${lastPosForPanic.lat},${lastPosForPanic.lng}` : "");

  if (phase === "setup") {
    return (
      <div>
        <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 12 }}>{t(lang, "deslocIntro")}</div>

        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <Chip active={tripMode === "time"} onClick={() => setTripMode("time")}>{t(lang, "deslocModeTime")}</Chip>
          <Chip active={tripMode === "destination"} onClick={() => setTripMode("destination")}>{t(lang, "deslocModeDestination")}</Chip>
        </div>

        {tripMode === "time" ? (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 6 }}>{t(lang, "deslocMinutesLabel")}</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
              {DESLOC_TIME_PRESETS.map((m) => (
                <Chip key={m} active={!customMin && durationMin === m} onClick={() => { setDurationMin(m); setCustomMin(""); }}>{m} min</Chip>
              ))}
            </div>
            <input
              type="number" min="1" value={customMin} onChange={(e) => setCustomMin(e.target.value)}
              placeholder={t(lang, "deslocCustomMinutes")}
              style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 8, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)" }}
            />
          </div>
        ) : (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 6 }}>{t(lang, "deslocDestHint")}</div>
            <window.PlaceSuggestInput
              value={destQuery}
              onChangeText={(v) => { setDestQuery(v); setDestPoint(null); }}
              onSelect={(s) => { setDestQuery(s.name); setDestPoint({ lat: s.lat, lng: s.lng }); }}
              placeholder={t(lang, "deslocDestPlaceholder")}
              style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)" }}
            />
          </div>
        )}

        <ContactsManager lang={lang} contacts={contacts} setContacts={setContacts} />

        <div style={{ marginTop: 14, marginBottom: 10, fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>
          <div style={{ marginBottom: 4 }}>{t(lang, "deslocFreeNote")}</div>
          <div>{t(lang, "deslocPremiumNote")}</div>
        </div>

        {!premium && (
          <Button variant="secondary" onClick={() => { if (window.changeTab) window.changeTab("perfil"); }} style={{ width: "100%", marginBottom: 10 }}>
            {t(lang, "upgradeButton")}
          </Button>
        )}

        {setupError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{setupError}</div>}

        <Button variant="primary" onClick={startTrip} style={{ width: "100%" }} icon={(p) => <Icon name="footprints" size={15} color="#fff" {...p} />}>
          {t(lang, "deslocStartBtn")}
        </Button>
      </div>
    );
  }

  if (phase === "active" || phase === "confirm") {
    return (
      <div>
        {riskBanner && (
          <div style={{ background: "var(--color-alert)", color: "#fff", borderRadius: 9, padding: "9px 12px", marginBottom: 10, fontSize: "var(--text-sm)", display: "flex", gap: 8, alignItems: "flex-start" }}>
            <Icon name="triangle-alert" size={16} color="#fff" style={{ flexShrink: 0, marginTop: 1 }} />
            <span>{t(lang, "deslocRiskAlertPrefix")} {riskBanner.catLabel}</span>
          </div>
        )}

        <div style={{ textAlign: "center", marginBottom: 10 }}>
          {tripMode === "time" ? (
            <>
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "deslocActiveTimeLabel")}</div>
              <div style={{ fontSize: 34, fontWeight: 700, color: "var(--color-brand-primary)", fontFamily: "var(--font-mono)" }}>{formatMMSS(remainingSec)}</div>
            </>
          ) : (
            <>
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "deslocActiveDistLabel")}</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: "var(--color-brand-primary)", fontFamily: "var(--font-mono)" }}>{formatDistanceM(distanceRemainingM)}</div>
            </>
          )}
        </div>

        {shareUrl && (
          <Button variant="secondary" onClick={shareTrip} style={{ width: "100%", marginBottom: 10 }} icon={(p) => <Icon name="share-2" size={14} {...p} />}>
            {t(lang, "deslocShareTrip")}
          </Button>
        )}

        {currentPos && <DeslocMap pos={currentPos} path={path} dest={destPoint} />}

        {phase === "confirm" && (
          <div style={{ marginTop: 12, border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, textAlign: "center" }}>
            <div style={{ fontSize: "var(--text-base)", fontWeight: 600, marginBottom: 4 }}>{t(lang, "deslocConfirmTitle")}</div>
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 10 }}>{t(lang, "deslocConfirmHint")}</div>
            {premium ? (
              <div className="vigi-desloc-pulse" style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 10 }}>
                {t(lang, "deslocInactivityWarning")} {inactivitySec}s
              </div>
            ) : (
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 10 }}>{t(lang, "deslocPremiumLockedHint")}</div>
            )}
            {tripMode === "time" && (
              <Button variant="ghost" onClick={() => extendTrip(5)} style={{ width: "100%", marginBottom: 8 }}>
                {t(lang, "deslocExtendBtn")}
              </Button>
            )}
          </div>
        )}

        <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
          <Button variant="primary" onClick={confirmArrivedSafe} style={{ width: "100%" }} icon={(p) => <Icon name="check" size={15} color="#fff" {...p} />}>
            {t(lang, "deslocArrivedSafeBtn")}
          </Button>
          <Button variant="ghost" onClick={cancelTrip} style={{ width: "100%" }}>
            {t(lang, "deslocCancelBtn")}
          </Button>
        </div>
      </div>
    );
  }

  if (phase === "notifying") {
    return (
      <div style={{ textAlign: "center", padding: "30px 10px" }}>
        <Icon name="loader-circle" size={28} color="var(--color-alert)" />
        <div style={{ marginTop: 10, fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "deslocNotifying")}</div>
      </div>
    );
  }

  if (phase === "endedSafe") {
    return (
      <div style={{ textAlign: "center", padding: "24px 10px" }}>
        <Icon name="shield-check" size={34} color="var(--color-brand-primary)" />
        <div style={{ marginTop: 10, fontSize: "var(--text-base)", fontWeight: 600, marginBottom: 16 }}>{t(lang, "deslocEndedSafeTitle")}</div>
        <Button variant="primary" onClick={newTrip} style={{ width: "100%" }}>{t(lang, "deslocNewTripBtn")}</Button>
      </div>
    );
  }

  if (phase === "endedPanic") {
    return (
      <div>
        <div style={{ textAlign: "center", padding: "10px 10px 16px" }}>
          <Icon name="triangle-alert" size={30} color="var(--color-alert)" />
          <div style={{ marginTop: 8, fontSize: "var(--text-base)", fontWeight: 600, color: "var(--color-alert)" }}>{t(lang, "deslocEndedPanicTitle")}</div>
          <div style={{ marginTop: 4, fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "deslocEndedPanicHint")}</div>
        </div>
        {contacts.filter((c) => c.phone).map((c) => (
          <a key={c.id} href={waLink(c.phone, panicMsg)} target="_blank" rel="noreferrer"
            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "9px 12px", border: "1px solid var(--color-border)", borderRadius: 9, marginBottom: 8, textDecoration: "none" }}>
            <span style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)" }}>{c.name}</span>
            <span style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-primary)" }}>{t(lang, "deslocNotifyManualBtn")}</span>
          </a>
        ))}
        <Button variant="primary" onClick={newTrip} style={{ width: "100%", marginTop: 8 }}>{t(lang, "deslocImOkBtn")}</Button>
      </div>
    );
  }

  return null;
}
window.DeslocamentoMode = DeslocamentoMode;
